import React from "react";

const SubscriberPermissionsConfigPanel = ({
  t,
  newSubscriberPermissionExclusions,
  clearExcludedPermissions,
  permissionSearch,
  setPermissionSearch,
  filteredPermissions,
  excludedPermissionIdSet,
  toggleExcludedPermission,
}) => (
  <section className="system-config-panel">
    <div className="system-config-panel-head">
      <div>
        <h3>{t.newSubscriberPermissionsTitle || "New subscriber default permissions"}</h3>
        <p>{t.newSubscriberPermissionsDescription || "New subscriber Owner roles receive all permissions except the permissions selected below."}</p>
      </div>
      <button type="button" className="system-config-add-btn secondary" onClick={clearExcludedPermissions} disabled={!newSubscriberPermissionExclusions.excludedPermissionIds.length}>
        {t.clearExcludedPermissions || "Clear exclusions"}
      </button>
    </div>

    <div className="system-config-permission-summary">
      <strong>{newSubscriberPermissionExclusions.excludedPermissionIds.length}</strong>
      <span>{t.excludedPermissionsCount || "permissions excluded from new subscribers"}</span>
    </div>

    <input
      className="system-config-permission-search"
      value={permissionSearch}
      onChange={(event) => setPermissionSearch(event.target.value)}
      placeholder={t.searchPermissions || "Search permissions"}
    />

    <div className="system-config-permission-list">
      {filteredPermissions.map((permission) => {
        const permissionKey = String(permission.ids || permission.id);
        const checked = excludedPermissionIdSet.has(permissionKey) || excludedPermissionIdSet.has(String(permission.id));
        return (
          <label className={`system-config-permission-row ${checked ? "excluded" : ""}`} key={permission.id}>
            <input
              type="checkbox"
              checked={checked}
              onChange={() => toggleExcludedPermission(permissionKey)}
            />
            <span>
              <strong>{permission.name || permission.ids}</strong>
              <small>{permission.ids} · {[permission.category, permission.subcategory].filter(Boolean).join(" / ")}</small>
            </span>
            <em>{checked ? (t.excluded || "Excluded") : (t.willBeAdded || "Will be added")}</em>
          </label>
        );
      })}
      {filteredPermissions.length === 0 ? <div className="system-config-type-empty">{t.noPermissionsFound || "No permissions found."}</div> : null}
    </div>
  </section>
);

export default SubscriberPermissionsConfigPanel;
